var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9814 2.05942C20.346 1.92783 20.7542 2.01879 21.0283 2.29281C21.3023 2.56697 21.3934 2.97511 21.2617 3.33969L14.7617 21.3397C14.7523 21.3656 14.741 21.3918 14.7295 21.4168C14.6059 21.6862 14.4076 21.9149 14.1582 22.075C13.9086 22.2351 13.6178 22.3211 13.3213 22.3211C13.0246 22.3211 12.7331 22.2353 12.4834 22.075C12.2432 21.9208 12.0511 21.7027 11.9268 21.4461V21.4471L8.5752 14.745L1.87402 11.3944L1.875 11.3934C1.61833 11.269 1.3994 11.0772 1.24512 10.8368C1.08502 10.5871 1.00003 10.2964 1 9.99985C1 9.70331 1.08509 9.41257 1.24512 9.16293L1.30859 9.07113C1.46333 8.86429 1.66843 8.69884 1.9043 8.59067C1.92935 8.57919 1.95553 8.56878 1.98145 8.55942L19.9814 2.05942ZM10.5371 14.1971L13.252 19.6278L17.8564 6.87875L10.5371 14.1971ZM3.69238 10.0672L9.12305 12.7821L16.4424 5.46274L3.69238 10.0672Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.f984d053a3807215aa3af08225064aab.svg";
export { ForwardRef as ReactComponent };